<template>
  <div>
    <b-overlay :show="isLoading" rounded="sm">
      <div :class="[{ 'min-vh-100': isLoading }]">
        <CRow class="no-gutters px-3 px-sm-0 bg-white">
          <b-col class="d-flex my-2 justify-content-end">
            <FlowFilter
              :channelList="channelList"
              :filter="filter"
              :tierList="tierList"
              :languageActiveId="languageActiveId"
              v-on:setShowSearchBox="setShowSearchBox"
              v-on:searchIntent="searchIntent"
              v-on:setLanguageAvtive="setLanguageAvtive"
            />
          </b-col>
        </CRow>

        <!-- <b-row :class="isShowSearchBox ? 'show' : 'd-none'">
          <b-col class="d-flex justify-content-end">
            <b-input-group class="panel-input-serach w-30 mt-3 mr-3">
              <b-form-input
                id="product-search"
                class="input-serach"
                v-model="filterIntent.search"
                @keydown.enter="searchIntent"
                placeholder="ค้นหาชื่ออินเทนต์, คีย์เวิร์ด"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="searchIntent"
                  />
                </span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row> -->

        <div class="p-3 overflow-auto">
          <div class="d-inline-flex">
            <div
              v-for="(flows, index) in flowLists"
              :key="index"
              class="flow-box mr-1"
            >
              <template v-if="flows.level == 1">
                <div class="d-flex px-3 pt-2">
                  <div class="my-auto start-text font-weight-bold">
                    <span>START</span>
                  </div>
                  <div class="ml-auto">
                    <button
                      type="button"
                      class="my-md-2 btn btn-create-intent rounded-pill"
                      @click="handleCreateIntent"
                    >
                      <div>
                        <font-awesome-icon icon="plus" />
                        <span class="ml-2"> Create new intent</span>
                      </div>
                    </button>
                  </div>
                </div>
              </template>

              <template v-if="flows.flowLists.length == 0">
                <div
                  :class="[
                    'd-flex',
                    { 'flow-list-box-no-flow': !isSearching },
                    { 'flow-list-box-search': isSearching },
                  ]"
                >
                  <div class="m-auto" v-if="isSearching">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div
                    class="m-auto start-now-text"
                    v-else-if="!filterIntent.search"
                  >
                    Start now
                  </div>
                  <div class="m-auto start-now-text" v-else>ไม่พบข้อมูล</div>
                </div>
              </template>

              <template v-else-if="flows.flowLists.length > 0">
                <FlowLists
                  class="px-3 flow-list-box mh-for-list-box"
                  :class="{ 'mt-3': flows.level > 1 }"
                  v-bind:datalist="flows.flowLists"
                  v-bind:level="flows.level"
                  v-bind:flowActiveIds="flowActiveIds"
                  v-bind:showAllKeyword="showAllKeyword"
                  v-bind:channelList="channelList"
                  v-bind:tierList="tierList"
                  v-bind:languageActiveId="languageActiveId"
                  v-bind:filter="filter"
                  v-bind:filterIntent="filterIntent"
                  v-on:updateIntent="updateIntent"
                  v-on:getNextFlowLists="getNextFlowLists"
                  v-on:onReloadFlowList="onReloadFlowList"
                  v-on:setShowAllKeyword="setShowAllKeyword"
                  v-on:openNextFlowListFromButton="openNextFlowListFromButton"
                  v-on:createOrUpdateChildIntent="createOrUpdateChildIntent"
                />
              </template>
            </div>

            <div
              class="card flow-box-level p-3 mx-2"
              cols="4"
              v-if="flowLists && flowLists.length > 0"
            ></div>
          </div>
          <SidebarIntent
            ref="sidebarIntent"
            :form="form"
            :languageList="languageList"
            :languageActiveId="languageActiveId"
            :sentimentActiveId="sentimentActiveId"
            :isSentiment="isSentiment"
            :v="$v"
            :intentLevel="intentLevel"
            :intentTypeList="intentTypeList"
            v-bind:channelList="channelList"
            v-bind:tierList="tierList"
            :apiConfigList="apiConfigList"
            :allFirstFlowList="allFirstFlowList"
            v-on:createOrUpdateIntent="createOrUpdateIntent"
            v-on:setLanguageAvtive="setLanguageAvtive"
            v-on:setSentimentActive="setSentimentActive"
            v-on:setIsSentiment="setIsSentiment"
            v-on:onIntentTypeChange="onIntentTypeChange"
            v-on:onApiConfigChange="onApiConfigChange"
            />

          <ModalAlert
            ref="modalAlert"
            :text="modalMessage"
            v-on:hadleModalAlertClose="hadleModalAlertClose"
          />
          <ModalAlertError
            ref="modalAlertError"
            :text="modalMessage"
            :isErrorList="isErrorList"
            v-on:hadleModalAlertErrorClose="hadleModalAlertErrorClose"
          />
          <ModalAlertConfirm
            msg="ยืนยันการลบ ?"
            :text="modalMessage"
            btnConfirm="ลบ"
            colorBtnConfirm="danger"
            btnCancel="ยกเลิก"
            ref="ModalAlertConfirm"
            @confirm="btnDelete"
          />
          <ModalLoading ref="modalLoading" :hasClose="false" />
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import FlowLists from "@/views/pages/flow-builder/components/FlowLists";
import FlowFilter from "@/views/pages/flow-builder/components/FlowFilter";
import SidebarIntent from "@/views/pages/flow-builder/components/sidebar/SidebarIntent";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import {
  required,
  requiredIf,
  not,
  sameAs,
  minValue,
  helpers,
} from "vuelidate/lib/validators";

const validateMaxLength = (validateFlag, item) => {
  if (!validateFlag && item.length > 40) {
    return false;
  } else {
    return true;
  }
};

export default {
  components: {
    FlowFilter,
    FlowLists,
    SidebarIntent,
    ModalAlert,
    ModalAlertError,
    ModalLoading,
    ModalAlertConfirm,
  },
  data() {
    return {
      modalMessage: "",
      isLoading: true,
      isFetching: false,
      isDisables: true,
      isDisableBtn: false,
      isLoadingData: false,
      isShowSearchBox: false,
      isSuccess: false,
      isApprove: false,
      modalAlertShow: false,
      modalAlertShows: false,
      imgModals: null,
      msgModals: null,
      status: false,
      msgModal: null,
      textModal: null,
      flowLists: [],
      forceRefresh: true,
      intentTypeList: [],
      apiConfigList: [{ id: 0, name: "Please Select" }],
      filterIntent: {
        search: "",
        Language: 1,
      },
      languageList: [
        {
          id: 1,
          name: "TH",
          isActive: true,
        },
        {
          id: 2,
          name: "EN",
          isActive: true,
        },
      ],
      filter: {
        channel: [],
        tier: [],
      },
      flowSelected: {
        mainIntentId: -1,
      },
      flowActiveIds: [],
      allFirstFlowList: [{mainIntentId: 0, intentName: "Please Select" }],
      responseIdSelected: 0,
      showAllKeyword: false,
      languageActiveId: 1,
      sentimentActiveId: 1,
      isSentiment: false,
      intentLevel: 0,
      mainIntent: null,
      tempFlowLists: [],
      isErrorList: false,
      isSearching: false,
      form: {
        active: true,
        enableML: false,
        mainIntentId: 0,
        intentTypeId: 1,
        apiConfigId: 0,
        intentButtonId: 0,
        forwardToAgent: false,
        image: [],
        channel: [],
        tier: [],
        intent: [
          {
            intentId: 0,
            language: 1,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 1,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 1,
                  },
                },
              },
            ],
          },
          {
            intentId: 0,
            language: 2,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 2,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    Language: 2,
                  },
                },
              },
            ],
          },
        ],
      },
      channelList: [],
      tierList: [],
    };
  },
  validations() {
    return {
      form: {
        image: {},
        channel: { required },
        tier: { required },
        intent: {
          $each: {
            keyword: {
              required: requiredIf(function (item) {
                return (
                  item.language == this.languageActiveId &&
                  this.form.intentTypeId == 1
                );
              }),
            },
            name: {
              required: requiredIf(function (item) {
                return item.language == this.languageActiveId;
              }),
            },
            // [1] = type Text,  [2] = type Text/Button, [3] = type Text/Image, [4] = type Image, [5] = type Text/Image/Button, [46] = type Condition
            neutralReply: {
              $each: {
                content: {
                  ReplyType: {
                    required,
                    SameAsSelectedReplyType: (value, item) => {
                      return this.handleSameAsSelectedReplyType(value, item);
                    },
                  },
                  Text: {
                    Text: {
                      required: requiredIf(function (item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.neutralReply.some((reply) =>
                            [1, 2, 3, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag
                        );
                      }),
                    },
                  },
                  Button: {
                    $each: {
                      Label: {
                        required: requiredIf(function (item) {
                          var validateFlag = this.form.intent.some((intent) => {
                            return intent.neutralReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          });

                          return (
                            item &&
                            item.language == this.languageActiveId &&
                            validateFlag
                          );
                        }),
                        validateMaxLength(item) {
                          var statusCondition = this.form.intent.some(
                            (intent) => {
                              return intent.neutralReply.some((reply) =>
                                [2, 5].includes(reply.content.ReplyType)
                              );
                            }
                          );
                          var validateFlag =
                            item &&
                            item.language == this.languageActiveId &&
                            statusCondition;

                          return validateMaxLength(validateFlag, item);
                        },
                      },
                      Data: {
                        required: requiredIf(function (item) {
                          var validateFlag = this.form.intent.some((intent) => {
                            return intent.neutralReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          });
                          return (
                            item &&
                            item.language == this.languageActiveId &&
                            validateFlag
                          );
                        }),
                      },
                    },
                  },
                  Image: {
                    required: requiredIf(function (item) {
                      return (
                        item.ReplyType == 4 &&
                        item.language == this.languageActiveId
                      );
                    }),
                    ImageUrl: {
                      required: requiredIf(function (item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.neutralReply.some((reply) =>
                            [3, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag
                        );
                      }),
                    },
                  },
                  Product: {
                    required: requiredIf(function (item) {
                      return (
                        item.ReplyType == 10 &&
                        item.language == this.languageActiveId
                      );
                    }),
                  },
                  Condition: {
                    VariableId: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    SymbolId: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    Value: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    ReplyMainIntentIdTrue: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                      sameAsSelect: (value, item) => {
                        return this.handleSameAsSelect(value, item, 'ReplyMainIntentIdFalse');
                      },
                      SameAsSelectMainId: (value, item) => {
                        return this.handleSameAsSelectMainId(value, item);
                      },
                    },
                    ReplyMainIntentIdFalse: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                      sameAsSelect: (value, item) => {
                        return this.handleSameAsSelect(value, item, 'ReplyMainIntentIdTrue');
                      },
                      SameAsSelectMainId: (value, item) => {
                        return this.handleSameAsSelectMainId(value, item);
                      },
                    },
                  },
                  UserInput: {
                    SaveResponseAs : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    SuccessFormat : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    WrongFormat : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    Retry : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    }
                  }
                },
              },
            },
            negativeReply: {
              $each: {
                content: {
                  ReplyType: {
                  },
                  Text: {
                    Text: {
                      required: requiredIf(function (item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.negativeReply.some((reply) =>
                            [1, 2, 3, 5].includes(reply.content.ReplyType)
                          );
                        });

                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag &&
                          item.sameReplyAsNeutral == false
                        );
                      }),
                    },
                  },
                  Button: {
                    $each: {
                      Label: {
                        required: requiredIf(function (item) {
                          var validateFlag = this.form.intent.some((intent) => {
                            return intent.negativeReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          });

                          return (
                            item &&
                            item.language == this.languageActiveId &&
                            validateFlag &&
                            item.sameReplyAsNeutral == false
                          );
                        }),
                        validateMaxLength(item) {
                          var statusCondition = this.form.intent.some(
                            (intent) => {
                              return intent.neutralReply.some((reply) =>
                                [2, 5].includes(reply.content.ReplyType)
                              );
                            }
                          );
                          var validateFlag =
                            item &&
                            item.language == this.languageActiveId &&
                            statusCondition &&
                            item.sameReplyAsNeutral == false;

                          return validateMaxLength(validateFlag, item);
                        },
                      },
                      Data: {
                        required: requiredIf(function (item) {
                          var validateFlag = this.form.intent.some((intent) => {
                            return intent.negativeReply.some((reply) =>
                              [2, 5].includes(reply.content.ReplyType)
                            );
                          });
                          return (
                            item &&
                            item.language == this.languageActiveId &&
                            validateFlag &&
                            item.sameReplyAsNeutral == false
                          );
                        }),
                      },
                    },
                  },
                  Image: {
                    required: requiredIf(function (item) {
                      return (
                        item.ReplyType == 4 &&
                        item.language == this.languageActiveId &&
                        item.sameReplyAsNeutral == false
                      );
                    }),
                    ImageUrl: {
                      required: requiredIf(function (item) {
                        var validateFlag = this.form.intent.some((intent) => {
                          return intent.negativeReply.some((reply) =>
                            [3, 5].includes(reply.content.ReplyType)
                          );
                        });
                        return (
                          item &&
                          item.language == this.languageActiveId &&
                          validateFlag &&
                          item.sameReplyAsNeutral == false
                        );
                      }),
                    },
                  },
                  Product: {
                    required: requiredIf(function (item) {
                      return (
                        item.ReplyType == 10 &&
                        item.language == this.languageActiveId
                      );
                    }),
                  },
                  Condition: {
                    VariableId: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    SymbolId: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    Value: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    ReplyMainIntentIdTrue: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                      sameAsSelect: (value, item) => {
                        return this.handleSameAsSelect(value, item, 'ReplyMainIntentIdFalse');
                      },
                      SameAsSelectMainId: (value, item) => {
                        return this.handleSameAsSelectMainId(value, item);
                      },
                    },
                    ReplyMainIntentIdFalse: {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                      sameAsSelect: (value, item) => {
                        return this.handleSameAsSelect(value, item, 'ReplyMainIntentIdTrue');
                      },
                      SameAsSelectMainId: (value, item) => {
                        return this.handleSameAsSelectMainId(value, item);
                      },
                    },
                  },
                  UserInput: {
                    SaveResponseAs : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                      minValue: (value, item) => {
                        return this.handleMinValue(value, item);
                      },
                    },
                    SuccessFormat : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    WrongFormat : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    },
                    Retry : {
                      required: requiredIf(function (item) {
                        return (typeof item !== "undefined" && item);
                      }),
                    }
                  }
                },
              },
            },
          },
        },
      },
    };
  },
  watch: {
    languageActiveId: function () {
      this.addLanguageForValidateBeforeCreate();
      this.$v.form.$reset();
    },
    filter: {
      deep: true,
      handler() {
        this.onFilterFlowList();
      },
    },
  },
  created: async function () {
    this.getAllFirstFlowList();
    await this.getFlowLists(true);
    await this.getMasterData();
  },
  computed: {
    conditionIntent() {
      // เช็คบาง ReplyType สามารถเลือกได้ครั้งเดียวต่อ 1 intent
      let data = {
        "46": {
          countSelected: 0
        },
        "47": {
          countSelected: 0
        },
      }
      this.form.intent.forEach(intent => {
        intent.neutralReply.forEach((neutralReply, index) => {
          if(neutralReply.content.ReplyType === 46) {
            data['46'].countSelected += 1
          } else if(neutralReply.content.ReplyType === 47) {
            data['47'].countSelected += 1
          }
        });
      });
      return data 
    }
  },
  methods: {
    setShowSearchBox() {
      this.isShowSearchBox = !this.isShowSearchBox;
    },
    onIntentTypeChange(val) {
      this.form.intentTypeId = val;
    },
    onApiConfigChange(val) {
      this.form.apiConfigId = val;
    },
    onFilterFlowList() {
      let data = this.tempFlowLists.find((el) => el.level == 1);
      if (data && this.channelList.length > 0 && this.tierList.length > 0) {
        let filterListByChannel = data.flowLists.filter((el) =>
          el.channel.some((ele) => this.filter.channel.includes(ele))
        );
        let filterListByTier = filterListByChannel.filter((el) =>
          el.tier.some((ele) => this.filter.tier.includes(ele))
        );

        this.flowLists = [];
        let flow = {
          level: this.flowLists.length + 1,
          flowLists: filterListByTier,
        };
        this.flowLists.push(flow);
      }
    },
    setIsSentiment() {
      this.isSentiment = !this.isSentiment;
    },
    setSentimentActive(val) {
      this.sentimentActiveId = val;
    },
    setLanguageAvtive(val) {
      this.languageActiveId = val;
      this.filterIntent.Language = val;
    },
    getMasterData: async function () {
      await this.getChanelList();
      await this.getTierList();
      await this.getIntentTypeList();
      await this.getApiConfigList();
      this.isLoading = false;
    },
    getIntentTypeList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/flowBuilder/intentType`)
        .then((data) => {
          if (data.result == 1) {
            this.intentTypeList = data.detail;
          }
        });
    },
    getApiConfigList: async function () {
      await this.axios.get(`${this.$baseUrl}/apitrigger/all`).then((data) => {
        if (data.result == 1) {
          let apiConfigList = [{ id: 0, name: "Please Select" }];
          this.apiConfigList = apiConfigList.concat(data.detail.data);
        }
      });
    },
    getChanelList: async function () {
      await this.axios
        .get(`${this.$baseUrl}/masterdata/platform`)
        .then((data) => {
          if (data.result == 1) {
            this.channelList = data.detail;
            this.filter.channel = [];
            this.channelList.forEach((element) => {
              this.filter.channel.push(element.id);
            });
          }
        });
    },
    getTierList: async function () {
      await this.axios.get(`${this.$baseUrl}/masterdata/tier`).then((data) => {
        if (data.result == 1) {
          this.tierList = data.detail;
          this.filter.tier = [];
          this.tierList.forEach((element) => {
            this.filter.tier.push(element.id);
          });
        }
      });
    },
    openNextFlowListFromButton(level, item) {
      let flows = null;

      this.flowLists.find((el) => {
        if (el.level == level + 1) {
          el.flowLists.find((element) => {
            if (item.IntentHierarchyId == element.mainIntentId) {
              flows = element;
            }
          });
        }
      });

      if (flows) {
        this.getNextFlowLists(level + 1, flows);
      }
    },
    handleCloseModal() {
      this.modalAlertShow = false;
      if (this.isSuccess) {
        this.$refs.sidebarIntent.hide(false);
      }
    },
    setShowAllKeyword() {
      this.showAllKeyword = !this.showAllKeyword;
    },
    handleForcefresh() {
      this.forceRefresh = false;
      this.$nextTick(() => {
        this.forceRefresh = true;
      });
    },
    updateIntent: async function (item, level) {
      await this.checkParent(level, item);
      this.intentLevel = level - 1;
      if (item.intentTypeId == 0) {
        item.intentTypeId = this.intentTypeList[0].id;
      }
      this.form = JSON.parse(JSON.stringify(item));
      await this.addLanguageForValidateBeforeCreate();
      this.$v.form.$reset();
      this.sentimentActiveId = 1;
      this.responseIdSelected = item.mainIntentId;
      this.$nextTick(() => {
        this.$refs.sidebarIntent.show(true);
      });

      if (
        item.mainIntentId !== this.flowSelected.mainIntentId &&
        !this.flowActiveIds.includes(item.mainIntentId)
      ) {
        this.getNextFlowLists(level, item);
      }
    },
    createOrUpdateChildIntent: async function (item, level, mainIntent) {
      await this.checkDisplyLanguage(mainIntent, level);
      this.intentLevel = level;
      this.mainIntent = mainIntent;
      this.responseIdSelected = item.Id;
      this.setForm();
      this.sentimentActiveId = 1;
      this.form.channel = mainIntent.channel;
      this.form.tier = mainIntent.tier;
      let index = this.form.intent.findIndex(
        (el) => el.language == this.languageActiveId
      );
      if (index > -1) {
        this.form.intent[index].keyword.push(item.Data);
      }
      this.form.intentButtonId = item.Id;
      this.$refs.sidebarIntent.show(true);
    },
    checkParent(level, item) {
      let parent = null;
      this.flowLists.forEach((element) => {
        if (element.level == level - 1) {
          element.flowLists.forEach((flow) => {
            flow.intent.forEach((intent) => {
              intent.neutralReply.forEach((neutral) => {
                if ([2, 5].includes(neutral.content.ReplyType)) {
                  neutral.content.Button.forEach((button) => {
                    if (button.IntentHierarchyId == item.mainIntentId) {
                      parent = flow;
                    }
                  });
                }
              });
            });
          });
        }
      });
      if (parent) {
        this.checkDisplyLanguage(parent, level - 1);
      } else {
        this.checkDisplyLanguage(item, level - 1);
      }
    },
    checkDisplyLanguage(mainIntent, level) {
      this.languageList = [];
      if (level > 0) {
        if (mainIntent.intent[0].name) {
          this.languageList.push({
            id: 1,
            name: "TH",
            isActive: true,
          });
        }

        if (mainIntent.intent[1].name) {
          this.languageList.push({
            id: 2,
            name: "EN",
            isActive: true,
          });
        }
      } else {
        this.languageList = [
          {
            id: 1,
            name: "TH",
            isActive: true,
          },
          {
            id: 2,
            name: "EN",
            isActive: true,
          },
        ];
      }
    },
    createOrUpdateIntent: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        //if NegativeReply reply error set sentiment to 2
        this.form.intent.forEach((intent, index) => {
          intent.negativeReply.forEach((reply, rindex) => {
            if (
              this.$v.form.intent.$each.$iter[index].negativeReply.$each.$iter[
                rindex
              ].$error
            ) {
              this.sentimentActiveId = 2;
            } else {
              this.sentimentActiveId = 1;
            }
          });
        });
        return;
      } else {
        this.removeUnusedPropertyBeforeSubmit();
      }
    },
    setSameAsNeutralReply: async function () {},
    addLanguageForValidateBeforeCreate: async function () {
      this.form.intent.forEach((intent) => {
        //NeutralReply
        intent.neutralReply.forEach((neutral) => {
          if (neutral.content.Text) {
            neutral.content.Text.language = intent.language;
          }
          if (neutral.content.Image) {
            if (neutral.content.ReplyType == 4) {
              neutral.content.Image.forEach((element) => {
                element.language = intent.language;
              });
            } else {
              neutral.content.Image.language = intent.language;
            }
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              button.language = intent.language;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.language = intent.language;
          }
        });

        //NegativeReply
        intent.negativeReply.forEach((neutral) => {
          if (neutral.content.Text) {
            neutral.content.Text.language = intent.language;
          }
          if (neutral.content.Image) {
            if (neutral.content.ReplyType == 4) {
              neutral.content.Image.forEach((element) => {
                element.language = intent.language;
              });
            } else {
              neutral.content.Image.language = intent.language;
            }
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              button.language = intent.language;
              button.setSameAsNeutralReply = intent.setSameAsNeutralReply;
            });
          }
          if (neutral.content.ReplyType == 4) {
            neutral.content.language = intent.language;
          }
        });
      });
    },
    removeUnusedPropertyBeforeSubmit() {
      this.form.intent.forEach((intent) => {
        //NeutralReply
        intent.neutralReply.forEach((neutral) => {
          if (neutral.content.Text) {
            delete neutral.content.Text.language;
          }

          if (neutral.content.Image) {
            if (neutral.content.ReplyType == 4) {
              neutral.content.Image.forEach((element) => {
                delete neutral.content.Image.language;
              });
            } else {
              delete neutral.content.Image.language;
            }
          }

          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              delete button.language;
            });
          }
          if (neutral.content.ReplyType == 4) {
            delete neutral.content.language;
          }
        });

        //NegativeReply
        intent.negativeReply.forEach((neutral) => {
          if (neutral.content.Text) {
            delete neutral.content.Text.language;
            delete neutral.content.Text.sameReplyAsNeutral;
          }
          if (neutral.content.Image) {
            delete neutral.content.Image.language;
            delete neutral.content.Image.setSameAsNeutralReply;
          }
          if (neutral.content.Button) {
            neutral.content.Button.forEach((button) => {
              delete button.language;
              delete button.setSameAsNeutralReply;
            });
          }
          if (neutral.content.ReplyType == 4) {
            delete neutral.content.language;
            delete neutral.content.setSameAsNeutralReply;
          }
        });
      });

      this.submit();
    },
    submit: async function () {
      this.$refs.modalLoading.show();
      await this.axios
        .post(`${this.$baseUrl}/flowBuilder/save`, this.form)
        .then((data) => {
          if (data.result == 1) {
            this.modalMessage = "สำเร็จ";
            this.$refs.modalLoading.hide();
            this.$refs.modalAlert.show();
          } else {
            this.iaErrorList = true;
            this.modalMessage = data.detail;
            this.$refs.modalLoading.hide();
            this.$refs.modalAlertError.show();
          }
        });
    },
    hadleModalAlertErrorClose() {
      this.isErrorList = false;
    },
    hadleModalAlertClose: async function () {
      this.flowSelected = {
        mainIntentId: -1,
      };

      this.$v.form.$reset();
      this.getAllFirstFlowList();
      await this.getFlowLists();
      this.flowActiveIds.forEach(async (element, index) => {
        let flow;
        this.flowLists.find((el) => {
          if (el.level == index + 1) {
            flow = el.flowLists.find(
              (flowElement) => flowElement.mainIntentId == element
            );
          }
        });
        if (flow) {
          await this.getNextFlowBilderLists(flow, index + 1, true);
        }
      });
      this.$refs.sidebarIntent.hide(false);
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(`${this.$baseUrl}/user/${this.requestDeleteUser.userId}`)
        .then((data) => {
          this.modalMessage = data.message;
          if (data.result == 1) {
            this.$refs.modalAlert.show();
            this.filter.PageNo = 1;
            this.$refs.modalAlert.hide();
            this.getList();
          } else {
            this.$refs.modalAlertError.show();
          }
        });
    },
    setForm() {
      this.form = {
        active: true,
        enableML: false,
        mainIntentId: 0,
        intentTypeId: 1,
        apiConfigId: 0,
        intentButtonId: 0,
        forwardToAgent: false,
        image: [],
        channel: [],
        tier: [],
        intent: [
          {
            intentId: 0,
            language: 1,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    language: 1,
                    sameReplyAsNeutral: true,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    language: 1,
                    sameReplyAsNeutral: true,
                  },
                },
              },
            ],
          },
          {
            intentId: 0,
            language: 2,
            name: "",
            sameReplyAsNeutral: true,
            keyword: [],
            neutralReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    language: 2,
                    sameReplyAsNeutral: true,
                  },
                },
              },
            ],
            negativeReply: [
              {
                id: 0,
                sortOrder: 1,
                content: {
                  ReplyType: 1,
                  Text: {
                    Id: 0,
                    Text: "",
                    language: 2,
                    sameReplyAsNeutral: true,
                  },
                },
              },
            ],
          },
        ],
      };
    },
    handleCreateIntent() {
      this.setForm();
      this.isSentiment = false;
      this.responseIdSelected = 0;
      this.sentimentActiveId = 1;
      this.intentLevel = 0;
      this.$v.form.$reset();
      this.languageList = [
        {
          id: 1,
          name: "TH",
          isActive: true,
        },
        {
          id: 2,
          name: "EN",
          isActive: true,
        },
      ];
      this.$refs.sidebarIntent.show(true);
    },
    onReloadFlowList: async function () {
      this.flowSelected = {
        mainIntentId: -1,
      };
      this.flowActiveIds = [];
      this.$v.form.$reset();
      this.responseIdSelected = 0;
      await this.getFlowLists();
    },
    searchIntent: async function (search) {
      this.filterIntent.search = search;
      this.isSearching = true;
      this.flowSelected = {
        mainIntentId: -1,
      };
      this.flowActiveIds = [];
      this.flowLists = [
        {
          level: this.flowLists.length + 1,
          flowLists: [],
        },
      ];
      await this.getFlowLists(true);
    },
    getFlowLists: async function () {
      await this.axios
        .post(`${this.$baseUrl}/flowBuilder/list/0`, this.filterIntent)
        .then((data) => {
          if (data.result == 1) {
            let flowList = data.detail.map((el) => {
              return { ...el, visible: false };
            });
            let flow = {
              level: 1,
              flowLists: flowList,
            };
            this.iaErrorList = false;
            this.isSearching = false;
            if (this.flowLists.length == 0) {
              this.flowLists = [];
              this.flowLists.push(flow);
              this.tempFlowLists.push(flow);
            } else {
              this.flowLists[0].flowLists = flowList;
              this.tempFlowLists[0].flowLists = flowList;
            }
          }
        });
    },
    getNextFlowLists: async function (level, flows) {
      if (
        flows.mainIntentId !== this.flowSelected.mainIntentId &&
        !this.flowActiveIds.includes(flows.mainIntentId)
      ) {
        this.flowSelected = flows;
        this.handleSelectedFlow(flows.mainIntentId, level);
        if (level < this.flowLists.length) {
          await this.deleteFlowLevel(level);
        }
        await this.getNextFlowBilderLists(flows, level);
      } else {
        this.flowSelected = { mainIntentId: -1 };
        if (this.flowActiveIds.includes(flows.mainIntentId)) {
          let target = this.flowActiveIds.findIndex(
            (el) => el == flows.mainIntentId
          );
          if (target > -1) {
            this.flowActiveIds.splice(target, 1);
          }
        }

        if (level < this.flowLists.length) {
          await this.deleteFlowLevel(level);
        }
      }
    },
    getNextFlowBilderLists: async function (flows, level, isFromEdit) {
      await this.axios
        .get(`${this.$baseUrl}/flowBuilder/list/${flows.mainIntentId}`)
        .then((data) => {
          if (data.result == 1) {
            if (data.detail.length > 0) {
              let flowList = data.detail.map((el) => {
                return {
                  ...el,
                  visible: false,
                  parent: flows.mainIntentId,
                };
              });
              if (!isFromEdit) {
                let flow = {
                  level: this.flowLists.length + 1,
                  flowLists: flowList,
                };
                this.flowLists.push(flow);
              } else {
                let flowListIndex = this.flowLists.findIndex(
                  (el) => el.level == level + 1
                );
                if (flowListIndex > -1) {
                  this.flowLists[flowListIndex].flowLists = flowList;
                }
              }
            }
            this.showAllKeyword = false;
          }
        });
    },
    deleteFlowLevel(level) {
      const result = this.flowLists.filter((el) => el.level <= level);
      this.flowLists = result;
    },
    setVisibleToFlow(flowId) {
      this.flowLists.forEach((element) => {
        element.flowLists.forEach((flow) => {
          if (flow.chatbotFlow.id == flowId) {
            flow.visible = !flow.visible;
          } else {
            flow.visible = false;
          }
        });
      });
    },
    handleSelectedFlow(flowId, level) {
      if (this.flowActiveIds[level - 1]) {
        this.flowActiveIds.splice(level, 1);
        this.flowActiveIds.splice(level - 1, 1);
        this.flowActiveIds[level - 1] = flowId;
      } else {
        this.flowActiveIds.push(flowId);
      }
    },
    getAllFirstFlowList: async function () {
      let allFirstFlowList = [{mainIntentId: 0, intentName: "Please Select" }];
      let filter = {
        search: "",
        Language: this.languageActiveId,
      };
      await this.axios
        .post(`${this.$baseUrl}/flowBuilder/list/0`, filter)
        .then(async (data) => {
          if (data.result == 1) {
            let filtered = await data.detail.filter(function(obj) {
              return obj.intent.length;
            }).map((el) => {
              return { ...el, visible: false, intentName: el.intent[this.languageActiveId-1].name || '' };
            });
            this.allFirstFlowList = allFirstFlowList.concat(filtered);
          }
        });
    },
    handleMinValue(value, item) {
      let result = false;
      if (typeof item !== "undefined") {
        if (value > 0) result = true;
      } else result = true;

      return result;
    },
    handleSameAsSelect(value, item, prop) {
      let result = false;
      if (typeof item !== "undefined") {
        if (value !== item[prop]) result = true;
      } else result = true;

      return result;
    },
    handleSameAsSelectMainId(value, item) {
      let result = false;
      if (typeof item !== "undefined") {
        if (value !== this.form.mainIntentId) result = true;
      } else result = true;

      return result;
    },
    handleSameAsSelectedReplyType(value, item) {
      let ReplyType = value.toString()
      let result = false;
      if (typeof item !== "undefined" && ['46','47'].indexOf(ReplyType) >= 0 ) {
        if(this.conditionIntent[ReplyType].countSelected < 2) result = true;
      } else result = true;

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.mh-for-list-box {
  height: calc(100vh - 270px);
}
.start-now-text {
  color: #bebebe;
}
.flow-builder {
  overflow: auto;
  min-width: 100rem;
}
::v-deep .c-main {
  min-width: 150% !important;
  overflow: auto;
}
.flow-box {
  background-color: white;
  height: calc(100vh - 190px);
  border-radius: 9px;
  width: 370px;
}
.flow-list-box {
  overflow: auto;
}

.flow-list-box-no-flow,
.flow-list-box-search {
  border: 2px solid #7d6da826;
  border-radius: 9px;
  overflow: auto;
  margin: 1rem 1rem 0rem;
  min-height: calc(100vh - 290px);
}
.flow-list-box-search {
  min-height: calc(100vh - 230px) !important;
}

.text-main-color {
  color: #16274a;
}
.bg-soft-light {
  background-color: #f1f1f1;
}
.bg-grey {
  background-color: #f1f1f5;
}
.btn-create-intent {
  background-color: #b41bb4;
  color: white !important;
}
.w-30 {
  width: 30%;
}
.flow-box-level {
  background-color: #f1f1f1;
  height: calc(100vh - 190px);
  overflow-y: auto;
  border-radius: 9px;
  width: 350px;
  border-color: #f1f1f1;
  margin: 0;
}
.flow-box-no-level {
  background-color: white;
  height: calc(100vh - 190px);
  overflow-y: auto;
  border-radius: 9px;
  width: 350px;
  border-color: white;
}
.start-box {
  background-color: #7d6da838;
  border-radius: 2px;
}
.start-text {
  color: #16274a;
}
.min-vh-70 {
  min-height: 70vh;
}
.min-vh-100 {
  min-height: 100vh;
}
</style>
